import { CloseIcon } from "../../../assets/icons"
import cx from "classnames"
import { useEffect, useMemo, useState } from "react"

import type { ToastVariant } from "./types"

import { Button } from "../button"
import styles from "./index.module.css"
import { TOAST_BUTTON_COLORS, TOAST_ICONS } from "./types"

export type ToastProps = {
  variant: ToastVariant
  message: string
  onClose?: () => void
  buttonText?: string
  onButtonClick?: () => void
  isExiting?: boolean
}

export const Toast = ({ message, buttonText, onClose, variant, onButtonClick, isExiting = false }: ToastProps) => {
  const [internalExiting, setInternalExiting] = useState(false)
  const CardIcon = useMemo(() => TOAST_ICONS[variant](), [variant])
  const toastClasses = cx(styles.toast, styles[variant], { [styles["toast-exiting"]]: internalExiting || isExiting })
  const isCloseable = !!onClose
  const buttonColor = TOAST_BUTTON_COLORS[variant]

  const handleClose = () => {
    setInternalExiting(true)
    if (onClose) {
      setTimeout(onClose, 300)
    }
  }

  useEffect(() => {
    if (isExiting) {
      setInternalExiting(true)
    }
  }, [isExiting])

  return (
    <div className={toastClasses} role="alert">
      <div className={styles.toastVariantIconContainer} role="img" aria-label={variant}>
        <span className={styles.toastVariantIcon}>{CardIcon}</span>
      </div>
      <main className={styles.toastContent}>
        <p className={styles.toastContentMessage}>{message}</p>
        {buttonText && (
          <Button onClick={onButtonClick} size="small" color={buttonColor} aria-label={buttonText}>
            {buttonText}
          </Button>
        )}
      </main>
      {isCloseable && (
        <div className={styles.toastCloseIconContainer}>
          <hr />
          <button
            className={styles.toastCloseIconButton}
            onClick={handleClose}
            aria-label="Close notification"
            data-testid="close-button"
          >
            <span className={styles.toastCloseIconButtonIcon} aria-hidden="true">
              <CloseIcon />
            </span>
          </button>
        </div>
      )}
    </div>
  )
}
